import numberService from '@components/ui-components/number-service/component.js'

export default {
  components: {
    'number-service-cmp': numberService,
  },
  data() {
    return {}
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/list/component.js